"use strict";import{tag as a}from"../custom-tag.js";export function freeIcon({height:e=16,width:l=16,hidden:r=!1,title:t="Free"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${e}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="free_svg__mask0_6875_6659"
        width="17"
        height="20"
        x="3"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="m3.4 18.378 14.84-14.84 1.735 1.737L5.136 20.114z"
        />
        <path
          fill="currentColor"
          fill-rule="evenodd"
          d="M17.32 17.85q1.208-1.203 1.208-3.028 0-1.827-1.164-2.926a5.4 5.4 0 0 0-1.235-.83l-3.027 3.027.088.044q.747.395.747 1.182 0 1.245-1.933 1.245-.672 0-1.162-.211l-2.494 2.494q.746.329 1.657.497V22h3.646v-2.593q2.417-.312 3.669-1.556m-9.678-5.659 2.994-2.994q-.3-.31-.301-.848 0-.54.395-.83.417-.29 1.164-.29.36 0 .652.059l2.448-2.449a7 7 0 0 0-1.342-.329V2h-3.647v2.51q-1.998.312-3.097 1.37Q5.744 7 5.744 8.722q0 1.742 1.076 2.822.34.345.822.647m-2.423 2.423-.02.021-.004-.02z"
          clip-rule="evenodd"
        />
      </mask>
      <g mask="url(#free_svg__mask0_6875_6659)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=free.js.map
